module.exports = __webpack_public_path__ + "img/SALVUS_CALENDAR.98e22aab.svg";